// MUTATIONS
export { default as AuthenticateUser } from './mutations/AuthenticateUser';
export { default as CreateApplication } from './mutations/CreateApplication';
export { default as CreateProperty } from './mutations/CreateProperty';
export { default as CreateStakeholder } from './mutations/CreateStakeholder';
export { default as InviteUser } from './mutations/InviteUser';
export { default as UpdateProperty } from './mutations/UpdateProperty';
export { default as UpdateStakeholder } from './mutations/UpdateStakeholder';

export { default as UpdatePropertyDocument } from './mutations/UpdatePropertyDocument';
export { default as UpdateUser } from './mutations/UpdateUser';
export { default as ValidateAdminUser } from './mutations/ValidateAdminUser';
export { default as CreateEvent } from './mutations/CreateEvent';

export { default as CreateProduct } from './mutations/CreateProduct';
export { default as AssignTicket } from './mutations/AssignTicket';

export { default as CreateGuest } from './mutations/CreateGuest';

// QUERIES
export { default as AllProperties } from './queries/AllProperties';
export { default as GetAllApplications } from './queries/GetAllApplications';
export { default as GetAllStakeholders } from './queries/GetAllStakeholders';
export { default as GetAllUsers } from './queries/GetAllUsers';
export { default as GetApplication } from './queries/GetApplication';
export { default as GetProperty } from './queries/GetProperty';
export { default as GetStakeholder } from './queries/GetStakeholder';
export { default as GetStakeholderDocuments } from './queries/GetStakeholderDocuments';
export { default as GetUser } from './queries/GetUser';
export { default as SearchProperties } from './queries/SearchProperties';
export { default as SearchStakeholders } from './queries/SearchStakeholders';
export { default as GetAllEvents } from './queries/GetAllEvents';
export { default as GetAllGuests } from './queries/GetAllGuests';
export { default as GetGuest } from './queries/GetGuest';



// WEBPACK FOOTER //
// ./src/graphql/index.ts